import { request } from '../utils/httpClient';
import { goRequest } from '../utils/httpClientTs';

export const getReciprocityTypes = () => {
  return goRequest({
    url: `/api/resources/reciprocity/types`,
    method: 'GET',
  });
};

export const getReciprocityList = (data) => {
  let url = `/resources/reciprocity?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.reciprocityType && data.reciprocityType !== 'all') {
    url += `&reciprocity_type=${data.reciprocityType}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getReciprocityDetail = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}`,
    method: 'GET',
  });
};

export const patchRCRoles = (data) => {
  let formId = data.formId;
  let roleId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/resources/reciprocity/${formId}/roles/${roleId}`,
    method: 'PATCH',
    data: data,
  });
};

export const postRCRoles = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/reciprocity/${formId}`,
    method: 'POST',
    data: data,
  });
};

export const replaceExistingRCRole = (data) => {
  let formId = data.formId;
  let leadershipId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/resources/reciprocity/${formId}/roles/${leadershipId}`,
    method: 'POST',
    data: data,
  });
};

export const deleteRCRoles = (data) => {
  return request({
    url: `/resources/reciprocity/${data.formId}/roles/${data.id}`,
    method: 'DELETE',
  });
};

export const addRCChapter = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}/chapters/${data.chapterId}`,
    method: 'POST',
  });
};

export const removeRCChapter = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}/chapters/${data.chapterId}`,
    method: 'DELETE',
  });
};

export const patchReciprocity = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/reciprocity/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const getIntlCommittees = (data) => {
  return goRequest({
    url: `/membership/international/standing_committees`,
    method: 'GET',
  });
};

export const getIntlAppointments = (data) => {
  return goRequest({
    url: `/membership/international/standing_appointments`,
    method: 'GET',
  });
};

export const getIntlBoard = (data) => {
  return goRequest({
    url: `/membership/international/board_of_directors`,
    method: 'GET',
  });
};

export const sendCommitteeMessage = (data) => {
  return goRequest({
    url: `/membership/international/committees/messages`,
    method: 'POST',
    data: data,
  });
};
